import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPeopleSelected = createSelector(
  [(store: RootState) => store.massNotification.selectedPeople],
  (item) => {
    const peopleListSorted = [...item].sort((a, b) => {
      if (a.name && b.name && a.name < b.name) {
        return -1;
      }
      if (a.name && b.name && a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return peopleListSorted;
  }
);
